export function ShDashboardsFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/sh-dashboards-filled.svg'"></ng-include>`
    }
}
            